import { SupportedLanguages } from '@migros/msrc-i18n';
import { HeadingTags, ListStyleType, TileLayout } from './enums';

// eslint-disable-next-line

export const defaultOptions = {
  mode: ListStyleType.default,
  language: SupportedLanguages.de,
  articlesPerPage: 48,
  sliderLimit: 12,
  sliderOffset: 0,
  hideDescription: false,
  hideRating: false,
  hideEnergyEfficiency: false,
  hideBadge: false,
  linkToFm: true,
  theme: 'mgbRiRi',
  headingTagsLevel: HeadingTags.h2,
  stickyHeadings: false,
  listicalFallback: false,
  productFilterOptions: {
    is_variant: false
  },
  offerFilterOptions: {},
  paginationOptions: {
    disabled: false,
    pageParamName: 'page',
    scrollOnPageClick: true,
    smoothScroll: true
  },
  tilesVisibleCount: {
    [TileLayout.default]: [1.5, 2.5, 3, 4, 4],
    [TileLayout.mini]: [1.2, 1.5, 2.5, 3.2, 3.2]
  },
  colCount: [2, null, 3, null, null] // TODO Should be changed to [2, null, 3, 4, null]
};
export const ARTICLE_TEXT_HEIGHT = 47; // in px

export const ARTICLE_TEXT_HEIGHT_TABLET = 59; // in px

export const ARTICLE_CONDENSED_TEXT_HEIGHT = 75; // in px

export const MINI_TILE_CONTENT_HEIGHT = 98; // in px

export const MINI_TILE_CONTENT_HEIGHT_TABLET = 120; // in px

export const ARTICLE_TEXT_HEIGHT_RATING = 15; // in px

export const MINI_TILE_BADGE_HEIGHT = '42px';
export const BADGE_HEIGHT = '48px';
export const MINI_TILE_BADGE_HEIGHT_TABLET = '64px';
export const BADGE_HEIGHT_TABLET = '64px';
export const MINI_TILE_IMAGE_SIZE = '64px';
export const MINI_TILE_IMAGE_SIZE_TABLET = '80px';
export const MINI_TILE_BADGE_OFFSET = '-18px';
export const MINI_TILE_BADGE_OFFSET_TABLET = '-28px';
export const DEFAULT_ARTICLE_LIST_SKELETON_COUNT = 6;
export const DEFAULT_ARTICLE_SLIDER_SKELETON_COUNT = 4;
export const FIRST_PAGE = 1;